<pos-app-spinner [show]="isLoading$ | async"></pos-app-spinner>
<form *ngIf="orderHeader" [formGroup]="form">
  <mat-tab-group class="order-header-tab" selectedIndex="0" [mat-stretch-tabs]="false">
    <mat-tab label="ORDER HEADER">
      <div class="py-2">
        <div class="row row-gap mx-0">
          <div class="col-4 d-flex align-items-center">
            <label class="d-flex align-items-center col-5"> CUSTOMER </label>
            <div class="col-7 nowrap text-start">
              <a
              class="form-control overflow-hidden text-truncate text-start"
              [ngClass]="{
                disabled: form.controls.orderType.value === 'SE' || ((isExternalUser || isProgrammeUser) && form.controls.orderType.value !== 'SQ') || orderHeader?.jobRequestOrderStatus !== 0
              }"
              (click)="editCustomer()"
              >
              <u>{{ form.controls.customerName.value }}</u>
              </a>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-5 text-uppercase">Phone</label>
            <div class="col-7">
              <div class="row">
                <div class="col-12">
                  <input class="form-control" value="{{ selectedCustomer?.phone }}" [readonly]="true" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-5 text-uppercase"
              >Salesperson <mat-icon title="Change Salesperson" (click)="changeSalesPerson()">edit</mat-icon>
            </label>
            <div class="col-7">
              <input class="form-control" value="{{ getSalesPersonNameOnly(orderHeader?.salesperson) }}" [readonly]="true" />
            </div>
          </div>
          <div class="col-4 d-flex align-items-center">
            <label class="col-5 text-uppercase">Order Status</label>
            <div class="col-7">
              <div class="input-group">
                <input class="form-control" value="{{ orderHeader?.jobRequestOrderStatusDescription }}" [readonly]="true" />
              </div>
            </div>
          </div>

          <div class="col-4 d-flex align-items-center">
            <label class="col-5">ORDER NO</label>
            <div class="col-7">
              <input class="form-control" formControlName="orderNumber" [readonly]="orderHeader?.readOnlyYN === 'Y'" />
            </div>
          </div>

          <div class="col-4 d-flex align-items-center">
            <label class="col-5">{{ orderHeader?.orderType === 'SE' ? 'PICK UP DATE' : 'REQUEST DATE' }}</label>

            <div class="col-7">
              <div class="input-group">
                <input
                  class="form-control"
                  name="d2"
                  ngbDatepicker
                  #d2="ngbDatepicker"
                  [dayTemplate]="customDay"
                  [footerTemplate]="footerTemplate"
                  formControlName="requestDate"
                  [placement]="'bottom-right'"
                  [class.is-invalid]="form.get('requestDate').errors?.invalid"
                  container="body"
                  [readonly]="true"
                  autoClose="false"
                  (navigate)="navigateCalendar($event)"
                  (keydown)="$event.preventDefault()"
                  [markDisabled]="isDisabled"
                  tabindex="-1"
                  style="background-color: #fff; cursor: pointer"
                />
                <div class="input-group-append">
                  <button
                    *ngIf="orderHeader?.readOnlyYN === 'N'"
                    class="btn btn-secondary calendar text-white btn-picker"
                    (click)="d2.open()"
                    (click)="streamOpened($event)"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="orderHeader?.orderType === 'SQ'" class="col-4 d-flex align-items-center">
            <label class="col-5 text-uppercase">Vehicle</label>
            <div class="col-7">
              <div class="input-group">
                <input class="form-control" value="{{ orderHeader?.vehicleDescription }}" [readonly]="true" />
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex pt-2">
          <div class="flex-grow-1" style="text-align: right">
            <label
              *ngFor="let message of headerMessages"
              [ngClass]="message.msgType === 'ERROR' ? 'text-danger' : message.msgType === 'WARN' ? 'text-warning' : 'text-success'"
              class="mx-2 text-uppercase"
            >
              *{{ message.message }}
            </label>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</form>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">ORDER NOTE</h3>
  </div>
  <div class="modal-body">
    <div *ngIf="!isGarage">
      <app-order-header-notes
        [preloadAttachments]="allAttachments"
        [orderNumber]="orderHeader.orderNumber"
        [orderType]="orderHeader.orderType"
        [orderCompany]="orderHeader.orderCompany"
        [isReadOnly]="isReadOnlyOrderNote"
        (reloadedAttachments)="loadAllAttachments.emit()"
        (closeActiveModal)="handleCloseModal($event)"
      ></app-order-header-notes>
    </div>
  </div>
</ng-template>

<ng-template #releaseOrderHoldModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">RELEASE ORDER HOLD</h3>
  </div>
  <div class="modal-body">
    <div class="row pb-2">
      <div class="col-4 my-auto">
        <label class="my-auto">PASSWORD</label>
      </div>
      <div class="col-8">
        <input type="password" class="form-control" [(ngModel)]="holdCodePassword" (keyup.enter)="onRemoveHoldCode()" />
      </div>
    </div>
    <div class="row pb-2">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-cancel mr-3" (click)="closeHoldCodeModal()">CANCEL</button>
        <button class="btn text-white" (click)="onRemoveHoldCode()" [disabled]="!holdCodePassword || (isBusy$ | async)">
          ENTER
          <pos-app-spinner2 *ngIf="isBusy$ | async"></pos-app-spinner2>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled">
  <div
    id="calanderDayParent{{ date.day }}{{ date.month }}{{ date.year }}"
    *ngIf="date.month === currentMonth"
    style="width: 50px; margin-left: -10px"
  >
    <div
      class="customCss"
      [class.hidden]="date.month !== currentMonth"
      id="calanderDayChild00{{ date.day }}{{ date.month }}{{ date.year }}"
      data-toggle="tooltip"
      data-placement="top"
      title=""
    >
      {{ date.day }}
    </div>
    <div id="calanderValue{{ date.day }}{{ date.month }}{{ date.year }}" style="justify-content: center; font-size: x-small"></div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <hr class="my-0" />
  <button class="btn btn-primary btn-sm m-2 float-end" (click)="updateHeaderDate()">DONE</button>
</ng-template>

<ng-template #changeSalespersonContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading text-uppercase" id="modal-basic-title">
      {{
        isClickAndCollect
          ? 'Assign Salesperson for this' + (orderHeader?.orderType === 'SE' ? ' Click and Collect Order' : ' E-Commerce Quote')
          : 'CHANGE SALESPERSON ON ORDER'
      }}
    </h3>
  </div>
  <div>
    <div class="modal-body">
      <pos-app-lib-customer-order-salesperson-selector
        [currentSalesPerson]="isClickAndCollect ? 'Not Assigned' : getSalesPersonNameOnly(orderHeader?.salesperson)"
        [orderNumber]="orderHeader?.orderNumber"
        [orderType]="orderHeader?.orderType"
        [JDEOrderType]="orderHeader?.jdeOrderType"
        [JDECompany]="orderHeader?.jdeCompany"
        [salesPeopleList]="salesPeopleList"
        (reloadData)="reloadData()"
        (closeActiveModal)="closeModal()"
        [isClickAndCollect]="isClickAndCollect"
        [isEcomQuote]="isEcomQuote"
      ></pos-app-lib-customer-order-salesperson-selector>
    </div>
  </div>
</ng-template>
